import React from 'react';

const Welcome = () => {
    return (
        <div>
            <h1 className=' tracking-widest text-6xl sp-style font-bold text-center mt-20'>WelCome To <br /><span className='text-primary sp-style text-4xl md:text-8xl logo'>Carparts Dashboard</span></h1>
        </div>
    );
};

export default Welcome;